import { API } from "../utils";

export const getTeams = async ({ params }) => {
  const response = API.get("/organization/teams", { params });
  const data = await response;
  return data;
};

export const createTeam = async ({ body }) => {
  const response = API.post("/organization/teams", body);
  const data = await response;
  return data;
};

export const deleteTeam = async ({ params }) => {
  const response = API.delete(`/organization/teams/${params.id}`);
  const data = await response;
  return data;
};

export const getSingleTeam = async ({ params }) => {
  const response = API.get(`/organization/teams/${params.id}`, { params });
  const data = await response;
  return data;
};

export const updateTeam = async ({ params, body }) => {
  const response = API.patch(`/organization/teams/${params.id}`, body);
  const data = await response;
  return data;
};

export const restoreTeam = async ({ params }) => {
  const response = API.put(`/organization/teams/${params.id}/restore`);
  const data = await response;
  return data;
};
